<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row" style="height:250px;">
    <div class="col-12" *ngIf="!dataCntrl.isReturned" style="padding:20px;font-size:16px;color:#1d3f94;"><b>Please choose the intervals for your forward timetable.</b></div>
    <div class="col-12" *ngIf="dataCntrl.isReturned" style="padding:20px;font-size:16px;color:#1d3f94;"><b>Please choose the intervals for your return timetable.</b></div>
      <div class="col-12">
        <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
          <table class="table table-sm table-borderless" style="margin-left:-10px;">
            <thead>
              <tr>
                <th style="text-align:center;width: 16%;">Select all</th>
                <th style="text-align:center;width: 12%;">Monday</th>
                <th style="text-align:center;width: 12%;">Tuesday</th>
                <th style="text-align:center;width: 12%;">Wednesday</th>
                <th style="text-align:center;width: 12%;">Thursday</th>
                <th style="text-align:center;width: 12%;">Friday</th>
                <th style="text-align:center;width: 12%;">Saturday</th>
                <th style="text-align:center;width: 12%;">Sunday</th>
              </tr>
            </thead>
            <tbody>

              <tr>
                <td>
                  <input formControlName="is_all" type="checkbox" (change)="isAll($event)" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:37%;" />
                </td>
                <td>
                  <input formControlName="is_for_day1" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />
                </td>
                <td>
                  <input formControlName="is_for_day2" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />
                </td>
                <td>
                  <input formControlName="is_for_day3" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />
                </td>
                <td>
                  <input formControlName="is_for_day4" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />
                </td>
                <td>
                  <input formControlName="is_for_day5" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />
                </td>
                <td>
                  <input formControlName="is_for_day6" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />
                </td>
                <td>
                  <input formControlName="is_for_day7" (change)="unSelectAll()" type="checkbox" class="form-control form-control-sm " style="margin-right:8px!important;margin-left:32%;" />
                </td>
              </tr>
              <tr></tr>
              <tr>
                <td colspan="8" *ngIf="!dataCntrl.isReturned" class="text-right" style="margin-top:10px!important;padding-top:35px!important;">
                  <button *ngIf="!isCreated" type="submit" id="btnSave" [disabled]="!isValidForm()"
                          class="btn hd-btn" style="width:auto; margin-left:10px; ">
                    <!-- <i class="fa fa-save"></i> -->
                    Save Timetable
                  </button>
                  <button *ngIf="isCreated" type="submit" id="btnCreate" [disabled]="!isValidForm()"
                          class="btn hd-btn" style="width:auto; margin-left:10px; ">
                    Proceed to create forward timetable
                  </button>

                </td>
                <td colspan="8" *ngIf="dataCntrl.isReturned" class="text-right" style="margin-top:10px!important;padding-top:10px!important;">
                    <button type="submit"  id="btnCreateReturn" [disabled]="!isValidForm()"
                          class="btn hd-btn" style="width:auto; margin-left:10px; ">
                   Proceed to create return timetable
                  </button>

                </td>
              </tr>

            </tbody>
          </table>
        </form>
      </div>

    </div>
  </div>
